import { alpha, getContrastRatio } from '@mui/material/styles';

export const getReportMetricKind = (value) => {
    const key = String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    if (/^(clicks?|uniqueclicks?|totalclicks?|linkclicks?|linkctr|ctr|clickthroughrate|clickrate)$/.test(key)) return 'click';
    if (/^(conversions?|totalconversions?|conv|convs|convrate|conversionrate|conversionpercent|convpercent|keyevents?)$/.test(key)) return 'conversion';
    return undefined;
};

export const getReportTotalColors = (theme) => ({
    background: theme.palette.primary.main,
    color: getContrastRatio(theme.palette.primary.main, '#ffffff') >= 4.5 ? '#ffffff' : '#111827',
});

export const getReportTableSx = (theme) => ({
    '& .MuiTableCell-root': { fontVariantNumeric: 'tabular-nums' },
    '& .MuiTableCell-body[data-report-metric="click"]': { background: `${alpha(theme.palette.primary.main, 0.14)} !important` },
    '& .MuiTableCell-body[data-report-metric="conversion"]': { background: `${alpha(theme.palette.primary.main, 0.26)} !important` },
    '& .MuiBox-root[data-report-metric="click"]': { background: alpha(theme.palette.primary.main, 0.14), p: 1, borderRadius: 1 },
    '& .MuiBox-root[data-report-metric="conversion"]': { background: alpha(theme.palette.primary.main, 0.26), p: 1, borderRadius: 1 },
    '& tfoot .MuiTableCell-root, & [data-report-total="true"] .MuiTableCell-root': {
        background: `${getReportTotalColors(theme).background} !important`,
        color: `${getReportTotalColors(theme).color} !important`,
        fontWeight: 800,
        '& a, & .MuiTypography-root': { color: 'inherit' },
    },
});
